import { Client, Tool } from '../../data/models/clients.model';
import { AppRoute, toolToAppRoute } from '../constants/route';
import { base64EncodeUrlSafe } from './base64.util';

export function convertNameToId(name: string) {
	return name.split(' ').join('_').toUpperCase();
}

export function getClientLandingNavigation(client: Client | null): string[] {
	const landingTool = client?.tools?.[0] ?? Tool.RAPID_LPR;
	if (landingTool === Tool.RAPID_LPR) {
		const firstPage = client?.reportPages?.[0];
		return firstPage ? [AppRoute.LprReport, base64EncodeUrlSafe(firstPage.name)] : [AppRoute.LprReport];
	}
	return [toolToAppRoute[landingTool]];
}
